import React, { useEffect } from 'react';
import HeaderV2 from '../../components/v2/HeaderV2';
import HeroV2 from '../../components/v2/HeroV2';
import ProblemV2 from '../../components/v2/ProblemV2';
import ProcessStripV2 from '../../components/v2/ProcessStripV2';
import FeaturedServicesV2 from '../../components/v2/FeaturedServicesV2';
import WhoWeHelpV2 from '../../components/v2/WhoWeHelpV2';
import WhyIllumiV2 from '../../components/v2/WhyIllumiV2';
import SelectedSystemsV2 from '../../components/v2/SelectedSystemsV2';
import AuditCTAV2 from '../../components/v2/AuditCTAV2';
import AboutV2 from '../../components/v2/AboutV2';
import FinalCTAV2 from '../../components/v2/FinalCTAV2';
import FooterV2 from '../../components/v2/FooterV2';
import useV2Language from '../../hooks/useV2Language';
import useDocumentLanguage from '../../hooks/useDocumentLanguage';
import { v2LandingCopy } from '../../data/v2LandingCopy';
import '../../styles/v2/tokens.css';
import '../../styles/v2/landing.css';
import '../../styles/v2/featured-services.css';

const LandingV2 = () => {
  const { lang, setLang, buildHref } = useV2Language();
  useDocumentLanguage(lang);
  const copy = v2LandingCopy[lang] || v2LandingCopy.en;

  useEffect(() => {
    document.title = lang === 'es' ? 'illumi.dev — Sistemas con intención' : 'illumi.dev — Systems with intention';
  }, [lang]);

  return (
    <div className="illumi-v2" data-testid="illumi-v2-landing">
      <HeaderV2 language={lang} onLanguageChange={setLang} buildHref={buildHref} />
      <main>
        <HeroV2 copy={copy.hero} buildHref={buildHref} />
        <ProblemV2 copy={copy.problem} />
        <ProcessStripV2 copy={copy.process} />
        <FeaturedServicesV2 language={lang} />
        <WhoWeHelpV2 copy={copy.whoWeHelp} />
        <WhyIllumiV2 copy={copy.whyIllumi} />
        <SelectedSystemsV2 copy={copy.selectedSystems} />
        <AuditCTAV2 copy={copy.auditCta} buildHref={buildHref} />
        <AboutV2 copy={copy.about} />
        <FinalCTAV2 copy={copy.finalCta} />
      </main>
      <FooterV2 language={lang} buildHref={buildHref} />
    </div>
  );
};
export default LandingV2;
